import type { IAccountPromo, IPromoAmount } from "@apis/rewards/types"

export function groupAccountPromos(items: IAccountPromo[]): IPromoAmount[] {
  const groupedPromos = items.reduce<Record<string, IPromoAmount>>((acc, p) => {
    if (!acc[p.promo_code]) {
      acc[p.promo_code] = {
        promo_code: p.promo_code,
        promo_name: p.promo.promo_name,
        amount: 0,
      }
    }
    acc[p.promo_code].amount++
    return acc
  }, {})

  return Object.values(groupedPromos).sort((a, b) =>
    a.promo_name < b.promo_name ? -1 : a.promo_name > b.promo_name ? 1 : 0,
  )
}

export const dateDiffInSeconds = (date: string): number => {
  return (new Date(date).getTime() - Date.now()) / 1000
}
